import { useQuery } from 'jsonapi-react';
import { createContext, type ReactNode, useContext } from 'react';

import { type Meal } from '../entities';

import { type DataContext } from '../types';

export const mealsContext = createContext<DataContext<Meal[]>>({
  data: [],
  isLoading: false,
  isFetching: false,
  refetch: () => {},
});

export const MealsProvider = ({ children }: { children: ReactNode }): ReactNode => {
  const meals = useQuery<Meal[]>([
    'meal',
    {
      sort: 'name',
      page: { limit: 10000 },
      include: [
        'mealItemAssignments.mealCategory',
        'mealItemAssignments.baseMealItem',
        'mealItemAssignments.baseMealItem.mealItemIngredients.ingredient',
        'mealItemAssignments.baseMealItem.mealItemIngredients.measure',
        'mealItemAssignments.measure',
        'mealItemAssignments.servingMeasure',
        'mealItemAssignments.servingTool',
        'mealItemAssignments.mealItemAssignmentIngredients.ingredient',
        'mealItemAssignments.mealItemAssignmentIngredients.measure',
      ],
      fields: {
        meal: ['name', 'mealItemAssignments', 'season', 'weekNumber'],
        'meal-item-assignment': [
          'baseMealItem',
          'mealCategory',
          'measure',
          'servingMeasure',
          'servingTool',
          'size',
          'servingSize',
          'serveType',
          'mealItemAssignmentIngredients',
        ],
        'meal-item': [
          'name',
          'measure',
          'servingMeasure',
          'servingTool',
          'size',
          'servingSize',
          'mealItemIngredients',
        ],
        'meal-category': ['name'],
        ingredient: ['name'],
        measure: ['name'],
        'meal-item-assignment-ingredient': ['ingredient', 'units', 'measure'],
        'meal-item-ingredient': ['ingredient', 'units', 'measure'],
      },
    },
  ]);
  return <mealsContext.Provider value={meals}>{children}</mealsContext.Provider>;
};
export const useMeals = (): DataContext<Meal[]> => useContext(mealsContext);
